export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14113.e23fe8c7.jpg";